const IsGTMScriptLoaded = () => {
  var scripts = document.getElementsByTagName('script');
  for (var i = scripts.length; i--;) {
      if (scripts[i].id === 'gtm_tag') return true;
  }
  return false;
};

export default IsGTMScriptLoaded;
